/**
 * Placeholder platform settings.
 *
 * `UserProfile/GetAccountSettings` covers one member's own preferences, not the
 * platform-wide switches an operator needs, and no admin settings endpoint
 * exists yet. The screen previews the shape of that feature; every control is
 * rendered under `SampleNotice` and cannot be saved.
 */
export type SampleSettingKind = 'toggle' | 'number';

export interface SampleSetting {
  key: string;
  kind: SampleSettingKind;
  /** i18n key suffix under `settings.items`. */
  labelKey: string;
  hintKey?: string;
  enabled?: boolean;
  amount?: number;
}

export interface SampleSettingGroup {
  /** i18n key suffix under `settings.groups`. */
  titleKey: string;
  items: readonly SampleSetting[];
}

export const SAMPLE_SETTING_GROUPS: readonly SampleSettingGroup[] = [
  {
    titleKey: 'community',
    items: [
      {
        key: 'allowSignUps',
        kind: 'toggle',
        labelKey: 'allowSignUps',
        hintKey: 'allowSignUpsHint',
        enabled: true,
      },
      {
        key: 'requireEmailVerification',
        kind: 'toggle',
        labelKey: 'requireEmailVerification',
        hintKey: 'requireEmailVerificationHint',
        enabled: true,
      },
    ],
  },
  {
    titleKey: 'moderation',
    items: [
      {
        key: 'autoHideReported',
        kind: 'toggle',
        labelKey: 'autoHideReported',
        hintKey: 'autoHideReportedHint',
        enabled: false,
      },
      { key: 'reportThreshold', kind: 'number', labelKey: 'reportThreshold', amount: 3 },
      {
        key: 'profanityFilter',
        kind: 'toggle',
        labelKey: 'profanityFilter',
        hintKey: 'profanityFilterHint',
        enabled: true,
      },
    ],
  },
  {
    titleKey: 'agents',
    items: [
      {
        key: 'agentsEnabled',
        kind: 'toggle',
        labelKey: 'agentsEnabled',
        hintKey: 'agentsEnabledHint',
        enabled: true,
      },
      { key: 'agentDailyCap', kind: 'number', labelKey: 'agentDailyCap', amount: 40 },
    ],
  },
  {
    titleKey: 'notifications',
    items: [
      {
        key: 'weeklyDigest',
        kind: 'toggle',
        labelKey: 'weeklyDigest',
        hintKey: 'weeklyDigestHint',
        enabled: true,
      },
      { key: 'pushEnabled', kind: 'toggle', labelKey: 'pushEnabled', enabled: true },
    ],
  },
];
